import React from 'react';
import { getStatusLabel, getStatusClass } from '../lib/utils';

export const StatusBadge = ({ status }) => {
    return (
        <span className={`status-badge ${getStatusClass(status)}`} data-testid={`status-badge-${status?.toLowerCase()}`}>
            {getStatusLabel(status)}
        </span>
    );
};

export default StatusBadge;
